import React from 'react'
import styled from 'styled-components'
import Switch from 'react-switch'

import { palette, mediaQueries } from '../../styles/variables'

export const Switcher = styled.div((props) => ({
  flex: 1,
  height: 40,
  width: props.width || '100%',
  minWidth: 'fit-content',
  maxWidth: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  fontSize: '15px',
  justifyContent: 'space-around',
  pointerEvents: props.disabled ? 'none' : 'inherit',
  '& .react-switch-handle': {
    left: 0,
    ...(props.disabled && {
      background: `${palette.lightGray} !important`,
    }),
  },
  '& .switch-left': {
    marginRight: '10px',
    color: props.disabled ? palette.lightGray : palette.darkGray,
  },
  '& .switch-right': {
    marginLeft: '10px',
    color: props.disabled ? palette.lightGray : palette.darkGray,
  },
  [mediaQueries.mobile]: {
    fontSize: '13px',
  },
}))

const NonDraggableSwitch = styled(Switch)`
  & .react-switch-handle {
    pointer-events: none;
  }
`

const SwitchToggle = ({
  testId,
  disabled,
  className,
  width,
  style,
  leftElement,
  disableDrag,
  onChange,
  checked,
  id,
  offColor,
  onColor,
  offHandleColor,
  onHandleColor,
  handleDiameter,
  switchHeight,
  switchWidth,
  rightElement,
}) => {
  return (
    <Switcher
      data-testid={testId}
      disabled={disabled}
      className={`switcher ${className}`}
      width={width}
      style={style}
    >
      <div className="switch-left">{leftElement}</div>
      {disableDrag ? (
        <NonDraggableSwitch
          onChange={onChange}
          checked={checked}
          id={id || 'switch-toggle'}
          offColor={offColor || palette.orange10}
          onColor={onColor || palette.orange10}
          offHandleColor={offHandleColor || palette.orange}
          onHandleColor={onHandleColor || palette.orange}
          handleDiameter={handleDiameter || 20}
          uncheckedIcon={false}
          checkedIcon={false}
          height={switchHeight || 15}
          width={switchWidth || 40}
        />
      ) : (
        <Switch
          onChange={onChange}
          checked={checked}
          id="switch-toggle"
          offColor={offColor || palette.orange10}
          onColor={onColor || palette.orange10}
          offHandleColor={offHandleColor || palette.orange}
          onHandleColor={onHandleColor || palette.orange}
          handleDiameter={handleDiameter || 20}
          uncheckedIcon={false}
          checkedIcon={false}
          height={switchHeight || 15}
          width={switchWidth || 40}
        />
      )}
      <div className="switch-right">{rightElement}</div>
    </Switcher>
  )
}
export default SwitchToggle
